








































import Vue, { PropType } from 'vue';
import moment from 'moment';
import { ServiceAssignment } from '@/types';
import { translateOrFallback } from '@/helpers/i18n';

export default Vue.extend({
  name: 'ServiceDayCard',

  props: {
    assignments: {
      type: Array as PropType<ServiceAssignment[]>,
      default: () => [],
    },
    title: {
      type: String,
      default: 'Serviceopdrachten',
    },
    emptyText: {
      type: String,
      default: 'Geen serviceopdrachten voor deze dag.',
    },
  },

  methods: {
    isFinished(assignment: ServiceAssignment): boolean {
      return assignment.status === 'finished';
    },

    time(assignment: ServiceAssignment): string {
      return assignment.start_at ? moment(assignment.start_at).format('HH:mm') : '';
    },

    typeLabel(assignment: ServiceAssignment): string {
      return translateOrFallback(this.$i18n, `service.types.${assignment.type}`, assignment.type);
    },
  },
});
